import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { FormField } from "./FormField";

export function FormPreview({
  title,
  description,
  fields,
  onSubmit,
  showsubmitButton = true,
}) {
  console.log("FormPreview rendered with fields:", fields);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const parsedFields = (() => {
    // Since fields are already parsed in the API processing, just ensure it's an array
    return Array.isArray(fields) ? fields : [];
  })();

  // const parsedFields = Array.isArray(fields)
  //   ? fields
  //   : typeof fields === "string"
  //   ? JSON.parse(fields)
  //   : [];

  console.log("FormPreview rendered with fields:", parsedFields);

  const handleFieldChange = (id, value) => {
    setFormData({
      ...formData,
      [id]: value,
    });
    // Clear error when field is updated
    if (errors[id]) {
      const newErrors = { ...errors };
      delete newErrors[id];
      setErrors(newErrors);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    parsedFields.forEach((field) => {
      if (field.required) {
        const value = formData[field.id];
        if (
          value === undefined ||
          value === "" ||
          (Array.isArray(value) && value.length === 0)
        ) {
          newErrors[field.id] = `${field.label} is required`;
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // In a real application, you would submit the form data to your backend
      console.log("Form submitted:", formData);
      // Call onSubmit callback if provided
      if (typeof onSubmit === "function") {
        onSubmit(formData);
      }
      setIsSubmitted(true);
    }
  };

  const handleReset = () => {
    setFormData({});
    setIsSubmitted(false);
  };

  // JSX Methods for modern design
  const renderSuccessState = () => (
    <div
      style={{
        textAlign: 'center',
        padding: '3rem 2rem',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e5e7eb'
      }}
    >
      <div
        style={{
          width: '80px',
          height: '80px',
          background: '#dcfce7',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 2rem',
          fontSize: '2rem'
        }}
      >
        ✓
      </div>

      <Alert
        variant="success"
        style={{
          background: '#f0fdf4',
          border: '1px solid #bbf7d0',
          borderRadius: '8px',
          marginBottom: '2rem'
        }}
      >
        <h4 style={{
          color: '#166534',
          fontSize: '1.5rem',
          fontWeight: '600',
          marginBottom: '0.5rem'
        }}>
          Thank You!
        </h4>
        <p style={{
          color: '#166534',
          marginBottom: 0,
          fontSize: '1rem'
        }}>
          Your submission has been received successfully.
        </p>
      </Alert>

      <button
        onClick={handleReset}
        style={{
          background: '#184778',
          border: 'none',
          borderRadius: '8px',
          padding: '12px 24px',
          color: 'white',
          fontSize: '0.875rem',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.2s ease'
        }}
        onMouseOver={(e) => {
          e.target.style.background = '#0f3a5f';
          e.target.style.transform = 'translateY(-1px)';
        }}
        onMouseOut={(e) => {
          e.target.style.background = '#184778';
          e.target.style.transform = 'translateY(0)';
        }}
      >
        Submit Another Response
      </button>
    </div>
  );

  const renderFormHeader = () => (
    <div
      style={{
        background: '#f9fafb',
        padding: '2rem',
        textAlign: 'center',
        borderBottom: '1px solid #e5e7eb',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px'
      }}
    >
      <h5 style={{
        fontSize: '1.5rem',
        fontWeight: '700',
        color: '#1f2937',
        marginBottom: '0.75rem',
        margin: 0
      }}>
        {title}
      </h5>
      {description && (
        <p style={{
          color: '#6b7280',
          fontSize: '1rem',
          lineHeight: '1.5',
          margin: 0,
          marginTop: '0.5rem'
        }}>
          {description}
        </p>
      )}
    </div>
  );

  const renderFormFields = () => (
    <div
      style={{
        background: 'white',
        padding: '2rem'
      }}
    >
      {parsedFields.length === 0 ? (
        <div
          style={{
            textAlign: 'center',
            padding: '3rem 2rem',
            color: '#6b7280'
          }}
        >
          <div
            style={{
              width: '60px',
              height: '60px',
              background: '#f3f4f6',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1rem',
              fontSize: '1.5rem'
            }}
          >
            📝
          </div>
          <p style={{ fontSize: '1rem', margin: 0 }}>
            This form has no fields yet.
          </p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {parsedFields.map((field) => (
            <FormField
              key={field.id}
              field={field}
              value={formData[field.id] || ""}
              onChange={(value) => handleFieldChange(field.id, value)}
              error={errors[field.id]}
            />
          ))}
        </div>
      )}
    </div>
  );

  const renderSubmitButton = () => (
    showsubmitButton && parsedFields.length > 0 && (
      <div
        style={{
          background: '#f9fafb',
          padding: '1.5rem 2rem',
          borderTop: '1px solid #e5e7eb',
          borderBottomLeftRadius: '12px',
          borderBottomRightRadius: '12px'
        }}
      >
        <button
          type="submit"
          className="btn btn-outline-primary "
        >
          Submit
        </button>
      </div>
    )
  );

  if (isSubmitted) {
    return renderSuccessState();
  }

  console.log("parsedFields:", parsedFields);

  return (
    <div
      style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}
    >
      {renderFormHeader()}

      <form onSubmit={handleSubmit}>
        {renderFormFields()}
        {renderSubmitButton()}
      </form>
    </div>
  );
}
